import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class FreeProductConfigStore {

  @setter @observable collectionIds;
  @setter @observable productIds;
  @setter @observable minOrderAmount;

  static create(data={}) {
    const instance = new FreeProductConfigStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "collectionIds": [],
      "productIds": [],
      "minOrderAmount": "",
    };
  }

  constructor(defaults=FreeProductConfigStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=FreeProductConfigStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "collectionIds", "accessor": "collection_ids"},
      {"field": "productIds", "accessor": "product_ids"},
      {"field": "minOrderAmount", "accessor": "min_order_amount"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }
}

export default FreeProductConfigStore;


